<div class="side-panel-component"
     [ngClass]="{ 'closed': panelClosed === true, 'opened': panelClosed === false, 'right': side === 'right'}">
    <div class="menu-container">
        <ng-content *ngIf="!panelClosed" select="[header]"></ng-content>
    </div>
    <div class="side-panel-container">
        <ng-container *ngIf="!panelClosed">
          <div *ngIf="(isSidePanelLoading | async) && side === 'right'">
            <inner-loader></inner-loader>
          </div>

          <div class="side-panel-title">
                <span>{{title}}</span>
                <img class="side-panel-opened" (click)="panelClosed = true" src="assets/images/general/chevron.svg">
            </div>
            <div class="side-panel-content">
                <ng-content *ngIf="!panelClosed" select="[container]"></ng-content>
            </div>
        </ng-container>

        <ng-container *ngIf="panelClosed">
            <div class="side-panel-title">
                <img class="side-panel-closed" (click)="panelClosed = false" src="assets/images/general/chevron.svg">
            </div>

            <div class="side-panel-closed-title">
                <span>{{title}}</span>
            </div>
        </ng-container>
    </div>
</div>
